Object.defineProperty (module.exports, "__esModule", { value: true });
module.exports.SharedObjectFlushStatus = module.exports.default = {
	FLUSHED: "flushed",
	PENDING: "pending"
};